export const muiAccordionSummaryTheme = {
  MuiAccordionSummary: {
    styleOverrides: {
      root: ({ theme }) => ({
        minHeight: 28,
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded > div::before': {
          transform: 'translateX(-50%) rotate(270deg)',
        },

        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded > div::after': {
          opacity: 0,
        },
        flexDirection: 'row',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
          transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
          '& .MuiTypography-root': {
            fontSize: 18,
          },
          paddingRight: 22,
          [theme.breakpoints.up('lg')]: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(3),
            '& .MuiTypography-root': {
              fontSize: 22,
            },
          },
        },
      }),
    },
  },
};
